/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(function ($) {
  var $body = $("body"),
    $doc = $(document),
    $html = $("html"),
    $win = $(window);

  $doc.ready(function () {
    theme.init();
  });

  var theme = {
    init: function () {
      if (
        $body.hasClass("template-collection") ||
        $body.hasClass("template-search")
      ) {
        this.clearAllFilter();
      }

      if ($body.hasClass("template-product")) {
        this.showmore_description();
        this.initScrollToReview();
        this.initReviewProductTab();
        this.initQuestionProductTab();
        this.initThumbnailHeight();
        this.checkShopifyAppBlock();
        this.initReviewNumber();
        this.exitStickyCart();
      }

      if ($body.hasClass("template-article")) {
        // this.initSwatchVariant();
        this.initSelectProduct();
        this.initAddAllToCart();
      }

      this.changeSwatchQs();
      this.initScrollTop();
      this.initButtonPosition();
    },

    showmore_description: function () {
      if (!$(".description_showmore").length) {
        return;
      }

      var $showmore_wrapper = $(".description_showmore").parent();

      var self = $showmore_wrapper,
        $showmore = self.find(".showmore"),
        $showless = self.find(".showless");

      if ($win.innerWidth() > 999) {
        if (self.innerHeight() > 380) {
          $showmore.show();
          self.css("max-height", 540);
          self.addClass("collapsed");
        } else {
          $showmore.hide();
          self.removeClass("collapsed");
        }
      } else {
        if (self.innerHeight() > 200) {
          $showmore.show();
          self.addClass("collapsed");
          self.css("max-height", 262);
        } else {
          $showmore.hide();
          self.removeClass("collapsed");
        }
      }

      $(".tabs-nav__item").on("click", function (e) {
        e.preventDefault();

        var blockContentId = $(this).attr("aria-controls");

        var $showmore_wrapper = $("#" + blockContentId).find(
          ".product-tabs__tab-item-content"
        );

        if ($win.innerWidth() <= 999) {
          $("#" + blockContentId + " collapsible-content").attr("open", "");
          $(
            ".product-tabs__tab-item-wrapper:not(#" +
              blockContentId +
              ") collapsible-content"
          ).removeAttr("open");
        }

        setTimeout(function () {
          $showmore_wrapper.each(function () {
            var self = $(this),
              $showmore = self.find(".showmore"),
              $showless = self.find(".showless");
            if ($showmore.hasClass("hide") != true) {
              if ($win.innerWidth() > 999) {
                if (self.innerHeight() > 380) {
                  $showmore.show();
                  self.css("max-height", 540);
                  self.addClass("collapsed");
                } else {
                  $showmore.hide();
                  self.removeClass("collapsed");
                }
              } else {
                if (self.innerHeight() > 200) {
                  $showmore.show();
                  self.addClass("collapsed");
                  self.css("max-height", 262);
                } else {
                  $showmore.hide();
                  self.removeClass("collapsed");
                }
              }
            }
          });
        }, 500);
      });

      var $showmore = $(".showmore"),
        $showless = $(".showless");

      $showmore.on("click", function () {
        var $showmore_wrapper = $(this)
            .closest(".description_showmore")
            .parent(),
          $showless = $showmore_wrapper.find(".showless");

        $showmore_wrapper.css("max-height", "none");
        $showmore_wrapper.addClass("open").removeClass("collapsed");
        $(this).removeClass("show").addClass("hide");
        $showless.removeClass("hide").addClass("show");
      });

      $showless.on("click", function () {
        var $showmore_wrapper = $(this)
            .closest(".description_showmore")
            .parent(),
          $showmore = $showmore_wrapper.find(".showmore");

        if ($win.innerWidth() > 999) {
          $showmore_wrapper.css("max-height", 540);
        } else {
          $showmore_wrapper.css("max-height", 262);
        }

        $showmore_wrapper.removeClass("open").addClass("collapsed");
        $(this).removeClass("show").addClass("hide");
        $showmore.removeClass("hide").addClass("show");
      });
    },

    /* ======  */

    clearAllFilter: function () {
      var btnClear = $(".Drawer__Footer .boost-pfs-filter-clear-all");
      btnClear.on("click", function (e) {
        e.preventDefault();

        var btnClearApp = $(
          ".boost-pfs-filter-refine-by .boost-pfs-filter-option-title .boost-pfs-filter-clear-all"
        );

        if (btnClearApp) {
          btnClearApp.trigger("click");
        }
      });
    },

    /* ========== */

    formatMoney: function (cents, format = "") {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || window.themeVariables.settings.moneyFormat;
      function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100).toFixed(precision);
        let parts = number.split("."),
          dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          ),
          centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      let value = "";
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ".");
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_no_decimals_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 0, "'");
          break;
      }
      if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value);
      } else {
        return formatString.replace(placeholderRegex, value);
      }
    },

    changeSwatchQs: function () {
      $(".selector-wrapper .swatch-element:first-child()").each(function () {
        var _self = $(this);
        _self.find('input[type="radio"]').trigger("click");
      });

      $(".selector-wrapper :radio").on("change", function (e) {
        var _self = $(this);
        var productItem = $(this).parents(".product-item");
        var productItemLayout = $(this).parents(".action");
        var get_json = productItem.data("json-product");
        var variantList = get_json.variants;
        var option_color = productItem
          .find(".option-color")
          .data("option-position");
        var optionIdx = _self
          .closest("[data-option-index]")
          .data("option-index");
        var swatches = productItemLayout.find(".swatch-element");
        var thisVal = _self.val();
        var selectedVariant;
        // debugger;
        var productInput = productItemLayout.find("[name=id]");
        var selectedSwatchOpt1 = productItemLayout
          .find(".selector-wrapper-1")
          .find("input:checked")
          .val();
        var selectedSwatchOpt2 = productItemLayout
          .find(".selector-wrapper-2")
          .find("input:checked")
          .val();
        var selectedSwatchOpt3 = productItemLayout
          .find(".selector-wrapper-3")
          .find("input:checked")
          .val();
        swatches.removeClass("is-disabled");
        swatches.find(":radio").prop("disabled", false);
        switch (optionIdx) {
          case 0:
            var availableVariants = variantList.find(function (variant) {
              if (option_color == 1) {
                return (
                  variant.option2 == thisVal &&
                  variant.option1 == selectedSwatchOpt2
                );
              } else {
                if (option_color == 2) {
                  return (
                    variant.option3 == thisVal &&
                    variant.option1 == selectedSwatchOpt2
                  );
                } else {
                  return (
                    variant.option1 == thisVal &&
                    variant.option2 == selectedSwatchOpt2
                  );
                }
              }
            });

            if (availableVariants != undefined) {
              selectedVariant = availableVariants;
            } else {
              // variant was sold out, so auto select other available variant
              var altAvailableVariants = variantList.find(function (variant) {
                if (option_color == 1) {
                  return variant.option2 == thisVal;
                } else {
                  if (option_color == 2) {
                    return variant.option3 == thisVal;
                  } else {
                    return variant.option1 == thisVal;
                  }
                }
              });
              selectedVariant = altAvailableVariants;
            }
            break;
          case 1:
            var availableVariants = variantList.find(function (variant) {
              if (option_color == 1) {
                return (
                  variant.option2 == selectedSwatchOpt1 &&
                  variant.option1 == thisVal &&
                  variant.option3 == selectedSwatchOpt3
                );
              } else {
                if (option_color == 2) {
                  return (
                    variant.option3 == selectedSwatchOpt1 &&
                    variant.option1 == thisVal &&
                    variant.option2 == selectedSwatchOpt3
                  );
                } else {
                  return (
                    variant.option1 == selectedSwatchOpt1 &&
                    variant.option2 == thisVal &&
                    variant.option3 == selectedSwatchOpt3
                  );
                }
              }
            });
            if (availableVariants != undefined) {
              selectedVariant = availableVariants;
            } else {
              var altAvailableVariants = variantList.find(function (variant) {
                if (option_color == 1) {
                  return (
                    variant.option2 == selectedSwatchOpt1 &&
                    variant.option1 == thisVal
                  );
                } else {
                  if (option_color == 2) {
                    return (
                      variant.option3 == selectedSwatchOpt1 &&
                      variant.option1 == thisVal
                    );
                  } else {
                    return (
                      variant.option1 == selectedSwatchOpt1 &&
                      variant.option2 == thisVal
                    );
                  }
                }
              });
              selectedVariant = altAvailableVariants;
            }
            break;
        }
        if (selectedVariant == undefined) return;

        $(this)
          .parents(".product-item__info")
          ?.find(
            '.product-item-meta .product-item-meta__swatch-list .color-swatch__radio[value="' +
              thisVal +
              '"]'
          )
          ?.trigger("click");
        $(this)
          .parents("form.variants")
          ?.find(".product-item__cta-wrapper .button")
          ?.attr("data-variant-id", selectedVariant.id);
        productInput.val(selectedVariant.id);

        var currencyFormat = window.themeVariables.settings.currencyCodeEnabled
          ? window.themeVariables.settings.moneyWithCurrencyFormat
          : window.themeVariables.settings.moneyFormat;

        var productPrices = $(this)
          .parents(".product-item__info")
          ?.find(".price:not(.price--highlight):not(.price--compare)");
        console.log(productPrices);

        newHtml = "";
        if (productPrices.length > 0) {
          if (selectedVariant.compare_at_price > selectedVariant.price) {
            newHtml +=
              '<span class="price price--highlight"><span class="visually-hidden">' +
              window.themeVariables.strings.productSalePrice +
              "</span>" +
              theme.formatMoney(selectedVariant.price, currencyFormat) +
              "<small>税込</small></span>";
            newHtml +=
              '<span class="price price--compare"><span class="visually-hidden">' +
              window.themeVariables.strings.productRegularPrice +
              "<small>税込</small></span>" +
              theme.formatMoney(
                selectedVariant.compare_at_price,
                currencyFormat
              ) +
              "</span>";
          } else {
            newHtml +=
              '<span class="price"><span class="visually-hidden">' +
              window.themeVariables.strings.productSalePrice +
              "</span>" +
              theme.formatMoney(selectedVariant.price, currencyFormat) +
              "<small>税込</small></span>";
          }
        }
        productPrices.html(newHtml);
        console.log(selectedVariant);
        // $(this).parents('.product-item__info')?.find('.price')?.html(theme.formatMoney(selectedVariant.price, currencyFormat) + '<small>税込</small>')
        theme.checkStatusSwatchQs(productItem, productItemLayout);
      });

      $(
        ".product-card__variant--popup--content select.single-option-selector"
      ).on("change", function () {
        var _self = $(this);
        var productItem = $(this).parents(".product-item");
        var productItemLayout = $(this).parents(".action");
        var get_json = productItem.data("json-product");
        var variantList = get_json.variants;
        var option_color = productItem
          .find(".option-color")
          .data("option-position");
        var optionIdx = _self.data("option");
        var swatches = productItem.find(".swatch-element");
        var thisVal = _self.val();
        var selectedVariant;
        var productInput = productItemLayout.find("[name=id]");
        var selectedSwatchOpt1 = productItemLayout
          .find('[data-option="option1"]')
          .val();
        var selectedSwatchOpt2 = productItemLayout
          .find('[data-option="option2"]')
          .val();

        switch (optionIdx) {
          case "option1":
            var availableVariants = variantList.find(function (variant) {
              return (
                variant.option1 == thisVal &&
                variant.option2 == selectedSwatchOpt2 &&
                variant.available
              );
            });
            if (availableVariants != undefined) {
              selectedVariant = availableVariants;
            } else {
              // variant was sold out, so auto select other available variant
              var altAvailableVariants = variantList.find(function (variant) {
                return variant.option1 == thisVal && variant.available;
              });
              selectedVariant = altAvailableVariants;
            }
            break;
          case "option2":
            var availableVariants = variantList.find(function (variant) {
              return (
                variant.option1 == selectedSwatchOpt1 &&
                variant.option2 == thisVal &&
                variant.available
              );
            });
            if (availableVariants != undefined) {
              selectedVariant = availableVariants;
            }
            break;
        }
        if (selectedVariant != undefined) {
          productInput.val(selectedVariant.id);
        }

        theme.checkStatusSwatchQs(productItem, productItemLayout);
      });
    },

    checkStatusSwatchQs: function (productItem, productItemLayout) {
      var get_json = productItem.data("json-product");
      var variantList = get_json.variants;
      var options = productItem.find("[data-option-index]");
      var option_color = productItem
        .find(".option-color")
        .data("option-position");
      if (productItemLayout == undefined) {
        productItemLayout = productItem;
      }

      var productItemInfo = productItemLayout.parents(".product-item__info");

      var selectedSwatchOpt1 = productItemLayout
        .find('[data-option-index="0"]')
        .find("input:checked")
        .val();
      var selectedSwatchOpt2 = productItemLayout
        .find('[data-option-index="1"]')
        .find("input:checked")
        .val();

      options.each(function () {
        var optionIndex = $(this).data("option-index");
        var swatch = $(this).find(".swatch-element");
        switch (optionIndex) {
          case 0:
            // loop through all swatchs in option 1 and filter sold out swatch
            swatch.each(function () {
              var swatchVal = $(this).data("value");
              var opt1Soldout = variantList.find(function (variant) {
                if (option_color == 1) {
                  return variant.option2 == swatchVal && variant.available;
                } else {
                  if (option_color == 2) {
                    return variant.option3 == swatchVal && variant.available;
                  } else {
                    return variant.option1 == swatchVal && variant.available;
                  }
                }
              });
              var optionUnavailable = variantList.find(function (variant) {
                if (option_color == 1) {
                  return variant.option2 == swatchVal;
                } else {
                  if (option_color == 2) {
                    return variant.option3 == swatchVal;
                  } else {
                    return variant.option1 == swatchVal;
                  }
                }
              });

              if (opt1Soldout == undefined) {
                if (optionUnavailable == undefined) {
                  $(this).addClass("unavailable");
                  $(this).removeClass("is-disabled");
                  $(this).removeClass("available");
                  $(this).find(":radio").prop("checked", false);
                } else {
                  $(this).addClass("is-disabled");
                  $(this).removeClass("unavailable");
                  $(this).removeClass("available");
                  $(this).find(":radio").prop("disabled", false);
                  productItemInfo
                    .find("[data-btn-addtocart]")
                    .addClass("unavailable")
                    .attr("disabled", true);
                  productItemInfo
                    .find("[data-select-product]")
                    .addClass("unavailable")
                    .attr("disabled", true);
                }
              } else {
                $(this).removeClass("is-disabled");
                $(this).removeClass("unavailable");
                $(this).addClass("available");
                $(this).find(":radio").prop("disabled", false);
                productItemInfo
                  .find("[data-btn-addtocart]")
                  .removeClass("unavailable")
                  .removeAttr("disabled");
                productItemInfo
                  .find("[data-select-product]")
                  .removeClass("unavailable")
                  .removeAttr("disabled");
              }
            });
            break;
          case 1:
            swatch.each(function () {
              var swatchVal = $(this).data("value");
              var opt1Soldout = variantList.find(function (variant) {
                if (option_color == 1) {
                  return (
                    variant.option2 == selectedSwatchOpt1 &&
                    variant.option1 == swatchVal &&
                    variant.available
                  );
                } else {
                  if (option_color == 2) {
                    return (
                      variant.option3 == selectedSwatchOpt1 &&
                      variant.option1 == swatchVal &&
                      variant.available
                    );
                  } else {
                    return (
                      variant.option1 == selectedSwatchOpt1 &&
                      variant.option2 == swatchVal &&
                      variant.available
                    );
                  }
                }
              });
              var optionUnavailable = variantList.find(function (variant) {
                if (option_color == 1) {
                  return (
                    variant.option2 == selectedSwatchOpt1 &&
                    variant.option1 == swatchVal
                  );
                } else {
                  if (option_color == 2) {
                    return (
                      variant.option3 == selectedSwatchOpt1 &&
                      variant.option1 == swatchVal
                    );
                  } else {
                    return (
                      variant.option1 == selectedSwatchOpt1 &&
                      variant.option2 == swatchVal
                    );
                  }
                }
              });
              if (opt1Soldout == undefined) {
                if (optionUnavailable == undefined) {
                  $(this).addClass("unavailable");
                  $(this).removeClass("is-disabled");
                  $(this).removeClass("available");
                  $(this).find(":radio").prop("checked", false);
                } else {
                  $(this).addClass("is-disabled");
                  $(this).removeClass("unavailable");
                  $(this).removeClass("available");
                  $(this).find(":radio").prop("disabled", false);
                  // $(this).find(':radio').prop('checked',true);
                  productItemLayout
                    .find("[data-btn-addtocart]")
                    .addClass("unavailable")
                    .attr("disabled", true);
                  productItemInfo
                    .find("[data-select-product]")
                    .addClass("unavailable")
                    .attr("disabled", true);
                }
              } else {
                $(this).removeClass("is-disabled");
                $(this).removeClass("unavailable");
                $(this).addClass("available");
                $(this).find(":radio").prop("disabled", false);
                productItemLayout
                  .find("[data-btn-addtocart]")
                  .removeClass("unavailable")
                  .removeAttr("disabled");
                productItemInfo
                  .find("[data-select-product]")
                  .removeClass("unavailable")
                  .removeAttr("disabled");
              }
            });
            break;
        }
      });

      if (
        productItemLayout
          .find(".swatch-element.is-disabled")
          .find("input:checked").length
      ) {
        productItemLayout
          .find("[data-btn-addtocart]")
          .addClass("disabled")
          .attr("disabled", true);
        productItemInfo
          .find("[data-select-product]")
          .addClass("unavailable")
          .attr("disabled", true);
      } else {
        productItemLayout
          .find("[data-btn-addtocart]")
          .removeClass("disabled")
          .removeAttr("disabled");
        productItemInfo
          .find("[data-select-product]")
          .removeClass("unavailable")
          .removeAttr("disabled");
      }

      productItemLayout
        .find(".selector-wrapper:not(.option-color)")
        .each(function () {
          if (
            $(this).find(".swatch-element").find("input:checked").length < 1
          ) {
            if ($(this).find(".swatch-element.available").length) {
              $(this)
                .find(".swatch-element.available")
                .eq("0")
                .find("label")
                .trigger("click");
            } else {
              $(this)
                .find(".swatch-element.is-disabled")
                .eq("0")
                .find("label")
                .trigger("click");
            }
          }
        });
    },

    initSelectProduct: function () {
      var btnSelectProduct = $(".product-content__featured-products").find(
        "button[data-select-product]"
      );
      btnSelectProduct.on("click", function (e) {
        e.preventDefault();
        if ($(this).hasClass("is-selected")) {
          $(this).text("この商品を選択");
          $(this).removeClass("is-selected");
        } else {
          $(this).addClass("is-selected");
          $(this).text("項目が選択されている");
        }
      });
    },

    initAddAllToCart: function () {
      var btnAddalltocart = $(
        ".product-content__featured-products .button--addalltocart"
      );
      btnAddalltocart.on("click", function (e) {
        e.preventDefault();
        var getData = {
          items: [],
        };

        document
          .querySelectorAll(
            ".product-content__featured-products .button[data-select-product]"
          )
          .forEach(function (element) {
            if (
              typeof element != "undefined" &&
              element.classList.contains("is-selected")
            ) {
              var variantId = element.getAttribute("data-variant-id");
              getData.items.push({
                id: variantId,
                quantity: 1,
              });
            }
          });

        if (getData.items.length > 0) {
          fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(getData),
          })
            .then(function (response) {
              if (response.status == 200) {
                window.location.href = "/cart";
              }
              return response.json();
            })
            .then(function (json) {
              if (json.status == 422) {
                alert(json.description);
              }
            })
            .catch(function (err) {
              console.error(err);
            });
        } else {
          alert("Please select product!");
        }
      });
    },

    initScrollTop: function () {
      var backToTop = $("#back-top");

      backToTop.off("click.scrollTop").on("click.scrollTop", function (e) {
        e.preventDefault();
        e.stopPropagation();

        $("html, body").animate(
          {
            scrollTop: 0,
          },
          400
        );
        return false;
      });
    },

    initScrollToReview: function () {
      var tabReview = $(".tabs-nav__item-list .review-tab");
      var btnReview = $(".product .product-meta__reference .rating__caption");

      btnReview.on("click", function () {
        if (tabReview.length > 0) {
          tabReview.each(function () {
            $(this).click();
          });
        }
      });
    },

    initButtonPosition: function () {
      var button = $(".product-list .product-list__prev-next");
      var image = $(
        ".product-item__image-wrapper--multiple .product-item__primary-image"
      );
      if (button.length > 0) {
        button.each(function () {
          $(this).css("top", "calc((" + image[0].height + "px / 2) - 28px)");
        });

        $win.on("resize", function () {
          button.each(function () {
            $(this).css("top", "calc((" + image[0].height + "px / 2) - 28px)");
          });
        });
      }
    },

    initReviewProductTab: function () {
      var button = $(".product__info .review-summary-container");
      if (button.length > 0) {
        button.on("click", function () {
          document.querySelector(".tabs-nav__item-list .review-tab").click();
          // document.querySelector(".uKomiWidgetSectionBtn .uKomiWidget-btn.uKomiWidgetWriteReviewBtn-btn").click();
         setTimeout(function(){
            document.querySelector(".product-tabs__tab-item-wrapper:not([hidden]) .showmore").click();
           if ($('.ukomistarRatingSummarySection').data('no-review')) {
             $("html, body").animate({scrollTop: $(".tabs-nav__item-list .review-tab").offset().top},1000);
           }
           
         },500)
  
        });
      }
    },

    initQuestionProductTab: function () {
      var c1 = setInterval(function () {
         var button = $(".product-meta__reference .ukomiAskQuestiionTagSection");
          if (button.length) {
              clearInterval(c1);
              button.on("click", function () {
                document.querySelector(".tabs-nav__item-list .review-tab").click();
                
                setTimeout(function(){
                  document.querySelector(".product-tabs__tab-item-wrapper:not([hidden]) .showmore").click();
                  if ($('.ukomistarRatingSummarySection').data('no-review')) {
                    $("html, body").animate({scrollTop: $(".tabs-nav__item-list .review-tab").offset().top},1000);
                  }
                },500)
            });
          }
      }, 1000);
    },

    initThumbnailHeight: function () {
      if ($win.innerWidth() > 999) {
        setTimeout(function(){
          var mainImageHeight = $(".flickity-viewport .product__media-item:first-child .product__media-image-wrapper img").height();
          $(".product--thumbnails-left .product__thumbnail-list").css("max-height",mainImageHeight + "px");
        },2000)
        

        $win.on("resize", function () {
          var mainImageHeight = $(".flickity-viewport .product__media-item:first-child .product__media-image-wrapper img").height();
          // console.log($(".flickity-viewport .product__media-item:first-child .product__media-image-wrapper img").height(),mainImageHeight)
          $(".product--thumbnails-left .product__thumbnail-list").css(
            "max-height",
            mainImageHeight + "px"
          );
        });
      }
    },

    checkShopifyAppBlock: function() {
      setTimeout(function(){
        if ($('.shopify-app-block').length > 0){
          $('.shopify-app-block').each(function() {
            var self= $(this)
            if(self.find('.th_pb_section').is(':empty') || self.find('.th_pb_qty_bundle_cls').is(':empty')) {
              self.hide();
            }
        })
      }
      }, 2000)
      
    },


    initReviewNumber: function() {
      setTimeout(function(){
         var numberReview = $('.review-widget-summary-container .starRating span:last-child'); 
        var reviewTab = $('.product-tabs .tabs-nav__item-list button:last-child');

        if (numberReview.length > 0 && reviewTab.length > 0) {
          reviewTab.html('レビュー ('+numberReview.text().split('件')[0]+')')
        }

        var checkNoReview = $('.template-product .product-meta__reference .review-summary-container .starRating span.ukmcustomfont-ukm-blank-star')

        if (checkNoReview.length == 5) {
          $('.template-product').addClass('no-review');
        }
      },3000)
     
    },

    exitStickyCart: function() {
      const checkExitStickyCart = setInterval(function() {
        const $item = $('#satcb_quantity');
        if ($item.length) {
          clearInterval(checkExitStickyCart);
          $('input#satcb_quantity').val(parseInt($('input.quantity-selector__input').val()));
        }
      },100)
    },
  };
})(jQuery);

$(document).ready(function () {
  var input_list = $('.product-item-meta .product-item-meta__swatch-list [has-coordinate]');
  if(input_list.length > 0) {
    input_list.each(function(index) {
      var self = $(this)
      self.find('[this-color]').trigger('click')
    })
  }
   $('.product__info .color-swatch-list .color-swatch, .product__info .block-swatch-list .block-swatch').on('click', function(){
    setTimeout(function(){
      var input_list = $('.product-item-meta .product-item-meta__swatch-list [has-coordinate]');
      if(input_list.length > 0) {
        input_list.each(function(index) {
          var self = $(this)
          self.find('[this-color]').trigger('click')
        })
      }
    },1000)
   })
});


